import { getSupportedLangCodes } from '@shared/utils'

export default function defineLanguage(lang) {
  const shortenLang = lang.split('-')[0]
  return ~getSupportedLangCodes().indexOf(shortenLang)
    ? shortenLang
    : getSupportedLangCodes()[0]
}
